import { IconContent } from '@icons';

export const firstPage: IconContent = {
    sm: '<path d="m6.63 8 4.15 4.15-.7.7L5.21 8l4.85-4.85.71.7L6.63 8Z"/><path d="M4.5 13V3h1v10h-1Z"/>',
};
